import { Injectable } from '@angular/core';
import { BaseViewModel } from '../../../../models/base/base-view-model';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs/operators';
import { Event, NavigationEnd, Router } from '@angular/router';

@Injectable()
export class SidebarNavViewModel extends BaseViewModel {
  constructor(private router: Router) {
    super();
  }

  private readonly collapsedRootPaths = ['high-guide', 'account'];

  private readonly _collapsed = new BehaviorSubject(false);
  public readonly collapsed$ = this._collapsed.pipe(distinctUntilChanged());
  connectToCollapsed = (collapsed: boolean) => this._collapsed.next(collapsed);

  // Driven by the route rather than the nav click so a reload or deep link lands in the same state.
  private readonly landedOnCollapsedRoute$ = this.router.events.pipe(
    filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd),
    map(navigationEnd => navigationEnd?.urlAfterRedirects),
    startWith(this.router.url),
    map(url => this.router.parseUrl(url)?.root?.children?.primary?.segments?.[0]?.path),
    distinctUntilChanged(),
    map(rootPath => this.collapsedRootPaths.includes(rootPath))
  );

  /* *** Local Threads of Execution *** */

  private readonly collapseWhenLandingOnCollapsedRoute = this.landedOnCollapsedRoute$
    .pipe(filter(landedOnCollapsedRoute => landedOnCollapsedRoute))
    .subscribeWhileAlive({
      owner: this,
      next: () => this.connectToCollapsed(true)
    });

  toggleCollapsed(): void {
    this._collapsed.update(it => !it);
  }
}
